<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-07 11:16:52
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-06-08 14:47:53
-->
<template>
  <div>
    <el-form :model="form" label-width="120px" label-position="left" ref="form">
      <el-form-item label="品牌名称" prop="company_name" :required="isEdit">
        <el-input v-if="isEdit" v-model="form.company_name" placeholder="请输入团队名称" style="width: 240px" show-word-limit maxlength="10"></el-input>
        <span class="yx-color-text-primary fz-14" v-else>{{config.company_name}}</span>
        <div slot="error"><span class="yx-color-danger">团队名称不可为空</span></div>
      </el-form-item>
      <el-form-item label="品牌Logo" prop="logo" :required="isEdit">
        <div v-if="isEdit" class="flex-row flex-align-end">
          <upload-img ref="upload" :widthAndHeight="[240, 240]" showLimitTip @saveCardLink="saveCardLink"></upload-img>
        </div>
        <el-image :src="config.logo" style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 2px" v-else >
          <div slot="error" class="image-slot">
            <img src="@/assets/public/img-empty1.png" alt="" width="80">
          </div>
        </el-image>
        <p slot="error" class="yx-color-danger">团队Logo不可为空</p>
      </el-form-item>
      <el-form-item v-if="isEdit" style="margin-top: 60px">
        <el-button @click="cancel" size="medium" :loading="loading">取消</el-button>
        <el-button type="primary" @click="save"  size="medium" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import UploadImg from '@/components/common/uploadImg';
import {setTeamConf} from '@/api/teamManage';
export default {
  name: 'GroupInfo',
  props: {
    mode: {
      type: String,
      default: 'show',
      validator: val => ['show', 'edit'].includes(val)
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.form.company_name = this.config.company_name;
    this.form.logo = this.config.logo || '';
    this.isEdit && this.$refs.upload.setImgs([this.form.logo]);
  },
  watch: {
    'config.company_name'(val) {
      this.form.company_name = val;
    },
    'config.logo'(val) {
      this.form.logo = val;
      this.isEdit && this.$refs.upload.setImgs([val]);
    },
    isEdit(val) {
      val && this.$nextTick(() => {
        this.form.company_name = this.config.company_name;
        this.form.logo = this.config.logo || '';
        this.$refs.upload.setImgs([this.config.logo]);
      });
    }
  },
  data() {
    return {
      form: {
        company_name: '',
        logo: ''
      },
      loading: false
    }
  },
  computed: {
    isEdit() {
      return this.mode === 'edit';
    }
  },
  methods: {
    cancel() {
      this.$refs.form.resetFields();
      this.$emit('cancel');
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.$confirm('确认修改团队信息吗？修改后立即生效', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          });
          this.loading = true;
          try {
            const {code} = await setTeamConf({...this.form});
            if(code === 0) {
              this.$message.success('品牌信息设置成功');
              this.$emit('refresh');
              this.$emit('cancel');
            }
            this.loading = false;
          } catch (error) {
            this.loading = false;
          }
        }
      });
    },
    saveCardLink(val) {
      this.form.logo = val;
    }
  },
  components: {
    UploadImg
  }
}
</script>